import {useEffect, useState} from "react";

export const ShowTask = ({tasklist,setTasklist,task,setTask}) => {
            const [now,setNow] = useState(Date.now());
            const [filter,setFilter] = useState("All");

            useEffect(()=>{
                const t = setInterval(()=> setNow(Date.now()),1000);
                return ()=> clearInterval(t);
            },[]);

            const handleEdit = (id)=>{
                const selectedTask=tasklist.find(todo => todo.id === id);
                setTask(selectedTask);
            }
            const handleDelete=(id)=>{
                const updatedTaskList=tasklist.filter(todo => todo.id !== id);
                setTasklist(updatedTaskList);
            }

    

            const toggleSubtask = (taskId, subId)=>{
                const updated = tasklist.map(t=>{
                    if(t.id !== taskId) return t;
                    return {...t, subtasks: t.subtasks.map(s => s.id===subId ? {...s, done: !s.done} : s)}
                });
                setTasklist(updated);
            }

            const toggleComplete = (id)=>{
              const updated = tasklist.map(t=> t.id === id ? {...t, completed: !t.completed} : t);
              setTasklist(updated);
            }

            const categories = ["All", ...Array.from(new Set(tasklist.map(t=>t.category || 'General')))].filter(Boolean);

            const filtered = filter === "All" ? tasklist : tasklist.filter(t=> (t.category||'General')===filter);

            const timeLeft = (d)=>{
                if(!d) return "-";
                const diff = new Date(d).getTime() - now;
                if(diff <= 0) return "Expired";
                const m = Math.floor(diff/60000); const s = Math.floor((diff%60000)/1000);
                return `${m}m ${s}s`;
            }

            return (
            <section className="showTask">
                    <div className="head">
                            <div>
                                    <span className="title">Todo</span>
                                    <span className="count">{tasklist.length}</span>
                            </div>
                            <div style={{display:'flex',gap:8,alignItems:'center'}}>
                                <select value={filter} onChange={e=> setFilter(e.target.value)}>
                                    {categories.map(c=> <option key={c}>{c}</option>)}
                                </select>
                                <button onClick={() => setTasklist([])} className="clearAll" >Clear All</button>
                            </div>
                    </div>
                    <ul>
                            { filtered.map((todo)=>(
                                    <li key={todo.id} style={{borderLeft: `6px solid ${todo.priority==='High' ? '#d9534f' : todo.priority==='Low' ? '#5bc0de' : '#f0ad4e'}`}}>
                    <p>
                        <label style={{display:'flex',alignItems:'center',gap:8}}>
                          <input type="checkbox" checked={!!todo.completed} onChange={()=> toggleComplete(todo.id)} />
                          <span className="name" style={{textDecoration: todo.completed ? 'line-through' : 'none', opacity: todo.completed ? 0.6 : 1}}>{todo.name}</span>
                        </label>
                        <span className="time">{todo.time}</span>
                    </p>
                                    <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap'}}>
                                        <span style={{padding:'4px 8px',borderRadius:6,background: todo.priority==='High' ? '#f8d7da' : todo.priority==='Low' ? '#d1ecf1' : '#fff3cd'}}>{todo.priority}</span>
                                        <span style={{fontSize:12}}>{todo.category||'General'}</span>
                                        <span style={{fontSize:12}}>Deadline: {todo.deadline ? new Date(todo.deadline).toLocaleString() : '-'}</span>
                                        <span style={{fontSize:12}}>Left: {timeLeft(todo.deadline)}</span>
                                    </div>
                                    {todo.subtasks && todo.subtasks.length>0 && (
                                        <ul className="subtasks">
                                            {todo.subtasks.map(s=> (
                                                <li key={s.id}><label><input type="checkbox" checked={!!s.done} onChange={()=> toggleSubtask(todo.id,s.id)} /> {s.text}</label></li>
                                            ))}
                                        </ul>
                                    )}
                                    <div style={{display:'flex',gap:8,marginTop:8}}>
                                        <i onClick={()=> handleEdit(todo.id)} className="bi bi-pencil-square" style={{cursor:'pointer'}}></i>
                                        <i onClick={()=> handleDelete(todo.id)} className="bi bi-trash" style={{cursor:'pointer'}}></i>
                                    </div>
                            </li>
                            ))} 
                    </ul>
            </section>
        )
}
